<template>
  <div>
    <head>
      <meta charset="utf-8" />
      <title>Valuation Roll Management</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta content="Valuation Roll Property Management System" name="description" />
      <meta content="County Revenue System" name="author" />
      <!-- App favicon -->
      <link rel="shortcut icon" href="assets/images/favicon.png">

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <NavigationBar/>
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- tool bar -->
          <ToolBarValuation/>
          <!-- end of toolbar -->

          <!-- Page Title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Valuation Roll Dashboard</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);" @click="gotTo('dashboard')">Dashboard</a></li>
                    <li class="breadcrumb-item active">Valuation Roll</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Summary Cards -->
          <div class="row mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Total Properties</p>
                      <h4 class="mb-0">{{totalProperties.toLocaleString()}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                          <span class="avatar-title">
                            <i class="bx bx-home font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Pending Updates</p>
                      <h4 class="mb-0">{{pendingUpdates.toLocaleString()}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-warning">
                          <span class="avatar-title">
                            <i class="bx bx-time-five font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Approved Today</p>
                      <h4 class="mb-0">{{approvedToday.toLocaleString()}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                          <span class="avatar-title">
                            <i class="bx bx-check-circle font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Total Revenue</p>
                      <h4 class="mb-0">{{formatPrice(totalRevenue)}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-info">
                          <span class="avatar-title">
                            <i class="bx bx-money font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Recent Activity -->
          <div class="row">
            <div class="col-xl-8">
              <div class="card">
                <div class="card-header">
                  <div class="d-flex align-items-center justify-content-between">
                    <h4 class="card-title mb-0">Recent Property Updates</h4>
                    <button @click="refreshRecentActivity" class="btn btn-sm btn-outline-primary" :disabled="loading">
                      <i class="bx bx-refresh" :class="{'bx-spin': loading}"></i>
                    </button>
                  </div>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table table-hover mb-0" v-if="!loading && recentUpdates.length > 0">
                      <thead class="table-light">
                      <tr>
                        <th>Reference</th>
                        <th>LR Number</th>
                        <th>Owner</th>
                        <th>Update Type</th>
                        <th>Status</th>
                        <th>Date</th>
                        <th>Action</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="update in recentUpdates" :key="update.id">
                        <td>
                          <span class="font-weight-bold text-primary">{{update.reference_number || update.referenceNumber}}</span>
                        </td>
                        <td>{{update.LRNumber}}</td>
                        <td>{{update.ownerNames}}</td>
                        <td>
                          <span class="badge bg-soft-info text-info">{{update.update_type || update.updateType}}</span>
                        </td>
                        <td>
                            <span class="badge" :class="getStatusBadge(update.status)">
                              {{update.status.toUpperCase()}}
                            </span>
                        </td>
                        <td>{{formatDate(update.submitted_date || update.submittedDate)}}</td>
                        <td>
                          <button @click="viewUpdateDetails(update)" class="btn btn-sm btn-primary" title="View Details">
                            <i class="bx bx-show"></i>
                          </button>

                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <!-- Loading State -->
                    <div v-if="loading" class="text-center py-4">
                      <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </div>

                    <!-- Empty State -->
                    <div v-if="!loading && recentUpdates.length === 0" class="text-center py-4">
                      <i class="bx bx-file font-size-48 text-muted"></i>
                      <h6 class="mt-2">No Recent Updates</h6>
                      <p class="text-muted">No property update requests found.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-4">
              <!-- Statistics -->
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title mb-0">System Statistics</h4>
                </div>
                <div class="card-body">
                  <div class="mb-3">
                    <div class="d-flex justify-content-between mb-1">
                      <span class="text-muted">Properties Updated This Month</span>
                      <span class="font-weight-bold">{{propertiesUpdatedThisMonth}}</span>
                    </div>
                    <div class="progress" style="height: 6px;">
                      <div class="progress-bar bg-primary" style="width: 75%"></div>
                    </div>
                  </div>

                  <div class="mb-3">
                    <div class="d-flex justify-content-between mb-1">
                      <span class="text-muted">Pending Approvals</span>
                      <span class="font-weight-bold text-warning">{{pendingApprovals}}</span>
                    </div>
                    <div class="progress" style="height: 6px;">
                      <div class="progress-bar bg-warning" style="width: 45%"></div>
                    </div>
                  </div>

                  <div class="mb-3">
                    <div class="d-flex justify-content-between mb-1">
                      <span class="text-muted">System Health</span>
                      <span class="font-weight-bold text-success">98.5%</span>
                    </div>
                    <div class="progress" style="height: 6px;">
                      <div class="progress-bar bg-success" style="width: 98%"></div>
                    </div>
                  </div>

                  <hr>

                  <div class="row text-center">
                    <div class="col-6">
                      <div class="mb-2">
                        <h5 class="font-size-20 mb-0">{{averageProcessingTime}}</h5>
                        <p class="text-muted mb-0">Avg Processing Time</p>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-2">
                        <h5 class="font-size-20 mb-0">{{approvalRate}}%</h5>
                        <p class="text-muted mb-0">Approval Rate</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Quick Search -->
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title mb-0">Quick Property Search</h4>
                </div>
                <div class="card-body">
                  <div class="input-group mb-3">
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Enter LR Number"
                        v-model="quickSearchLR"
                        @keyup.enter="quickSearchProperty"
                    >
                    <button @click="quickSearchProperty" class="btn btn-primary" :disabled="!quickSearchLR.trim()">
                      <i class="bx bx-search"></i>
                    </button>
                  </div>
                  <small class="text-muted">Search by LR Number for quick property access</small>
                </div>
              </div>
            </div>
          </div>

          <!-- Request Details Modal -->
          <RequestDetailsModal
              :show="showDetailsModal"
              :request="selectedUpdateAsRequest"
              @close="closeDetailsModal"
          />

        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              ©{{new Date().getFullYear()}} County Revenue System
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Valuation Roll Management System
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import router from "@/router";
import {paysol, biller, execute, execute2, executeDownload, getRight, landRate} from "@/api";
import moment from 'moment';
import ToolBarValuation from "@/components/valuation/ToolBar.vue";
import RequestDetailsModal from "@/components/valuation/RequestDetailsModal.vue";

export default {
  name: "ValuationDashboard",
  components: {
    ToolBarValuation,
    NavigationBar,
    RequestDetailsModal
  },

  data() {
    return {
      loading: false,
      quickSearchLR: '',

      // Dashboard statistics
      totalProperties: 0,
      pendingUpdates: 0,
      approvedToday: 0,
      totalRevenue: 0,
      propertiesUpdatedThisMonth: 0,
      pendingApprovals: 0,
      averageProcessingTime: '2.5 days',
      approvalRate: 87,

      // Recent updates data
      recentUpdates: [],

      // Modal management
      showDetailsModal: false,
      selectedUpdate: null
    }
  },

  computed: {
    selectedUpdateAsRequest() {
      if (!this.selectedUpdate) return null;

      // Transform update object to match request structure expected by RequestDetailsModal
      return {
        id: this.selectedUpdate.id,
        referenceNumber: this.selectedUpdate.reference_number || this.selectedUpdate.referenceNumber,
        reference_number: this.selectedUpdate.reference_number || this.selectedUpdate.referenceNumber,
        LRNumber: this.selectedUpdate.LRNumber,
        ownerNames: this.selectedUpdate.ownerNames,
        status: this.selectedUpdate.status,
        submitted_date: this.selectedUpdate.submitted_date || this.selectedUpdate.submittedDate,
        processed_date: this.selectedUpdate.processed_date || this.selectedUpdate.processedDate,
        processed_by: this.selectedUpdate.processed_by || this.selectedUpdate.processedBy,
        processed_by_id_no: this.selectedUpdate.processed_by_id_no || this.selectedUpdate.processedByIdNo,
        update_type: this.selectedUpdate.update_type || this.selectedUpdate.updateType,
        current_data: this.selectedUpdate.current_data || JSON.stringify({
          ownerNames: this.selectedUpdate.ownerNames,
          LRNumber: this.selectedUpdate.LRNumber,
          status: this.selectedUpdate.status
        }),
        requested_data: this.selectedUpdate.requested_data || JSON.stringify({}),
        requester_info: this.selectedUpdate.requester_info || JSON.stringify({
          fullName: this.selectedUpdate.ownerNames || 'N/A',
          relationship: 'owner'
        }),
        notes: this.selectedUpdate.notes || `Recent update request for ${this.selectedUpdate.LRNumber}`
      };
    }
  },

  mounted() {
    this.getDashboardData();
    this.getRecentUpdates();
    this.menuAccess();
  },

  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Valuation Roll Dashboard");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller)
          .then(() => {})
          .catch(() => {});
    },

    getRight(type) {
      return getRight(type);
    },

    getDashboardData() {
      this.loading = true;

      const data = new FormData();
      data.append("function", "getValuationDashboardData");

      execute2(data, landRate)
          .then((res) => {
            if (res.data.success) {
              const dashboardData = res.data.data;
              this.totalProperties = dashboardData.totalProperties || 0;
              this.pendingUpdates = dashboardData.pendingUpdates || 0;
              this.approvedToday = dashboardData.approvedToday || 0;
              this.totalRevenue = dashboardData.totalRevenue || 0;
              this.propertiesUpdatedThisMonth = dashboardData.propertiesUpdatedThisMonth || 0;
              this.pendingApprovals = dashboardData.pendingApprovals || 0;
            }
          })
          .catch((e) => {
            console.error('Error loading dashboard data:', e);
          })
          .finally(() => {
            this.loading = false;
          });
    },

    getRecentUpdates() {
      const data = new FormData();
      data.append("function", "getRecentPropertyUpdates");
      data.append("limit", "10");

      execute2(data, landRate)
          .then((res) => {
            if (res.data.success) {
              this.recentUpdates = res.data.data.updates || [];
            }
          })
          .catch((e) => {
            console.error('Error loading recent updates:', e);
          });
    },

    refreshRecentActivity() {
      this.loading = true;
      this.getRecentUpdates();
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },

    quickSearchProperty() {
      if (!this.quickSearchLR.trim()) return;

      // Store search term and navigate to properties page
      sessionStorage.setItem('propertySearchTerm', this.quickSearchLR.trim());
      this.gotTo('valuation-properties');
    },

    viewUpdateDetails(update) {
      // Set selected update and show modal
      this.selectedUpdate = update;
      this.showDetailsModal = true;
    },

    closeDetailsModal() {
      this.showDetailsModal = false;
      this.selectedUpdate = null;
    },

    getStatusBadge(status) {
      const badges = {
        'pending': 'bg-soft-warning text-warning',
        'under_review': 'bg-soft-info text-info',
        'approved': 'bg-soft-success text-success',
        'rejected': 'bg-soft-danger text-danger',
        'requires_documents': 'bg-soft-secondary text-secondary'
      };
      return badges[status] || 'bg-soft-secondary text-secondary';
    },

    formatPrice(value) {
      const formatter = new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      return formatter.format(value);
    },

    formatDate(dateString) {
      return moment(dateString).format('DD/MM/YYYY');
    },

    gotTo(route) {
      router.push(route);
    }
  }
}
</script>

<style scoped>
.bx-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.bg-soft-primary {
  background-color: rgba(50, 149, 239, 0.1);
}

.bg-soft-success {
  background-color: rgba(52, 195, 143, 0.1);
}

.bg-soft-info {
  background-color: rgba(80, 165, 241, 0.1);
}

.bg-soft-warning {
  background-color: rgba(244, 206, 109, 0.1);
}

.bg-soft-danger {
  background-color: rgba(244, 106, 106, 0.1);
}

.bg-soft-secondary {
  background-color: rgba(133, 146, 163, 0.1);
}

.mini-stats-wid:hover {
  transform: translateY(-2px);
  transition: all 0.3s ease;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.card:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
}
</style>